import { AppSidebar } from "@/components/layout/app/sidebar/app-sidebar";
import { AppRightSidebar } from "@/components/layout/app/sidebar/app-right-sidebar"
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { Outlet } from "react-router-dom";

const AppLayout = () => {
  return (
    <div className="flex flex-row w-full h-dvh">
      <SidebarProvider>
          <AppSidebar />
          <SidebarInset className="overflow-auto">
            <Outlet />
          </SidebarInset>
      </SidebarProvider>
      <div>
        <SidebarProvider>
          <AppRightSidebar />
        </SidebarProvider>
      </div>
    </div>
  );
};

export default AppLayout;
